import React from 'react'
import styled from 'styled-components';
import { ReactComponent as LoaderSvg } from '../../assets/icons/puff.svg';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  > svg {
    font-size: 32px;
    color: #fff;
  }
`;

const Loader = () => {
  return (
    <Container>
      <LoaderSvg/>
    </Container>
  )
}

export default Loader